module.exports = __webpack_public_path__ + "static/media/yuko.f873ee27.png";